// The Core reports failures as { exception: { code: "DP-422", description: "Client Error" } }.
// Its descriptions are written for developers, so the user sees a plain-language text chosen
// by the error code; the code stays in brackets so support can trace the exact failure.
const FRIENDLY_BY_CODE = {
  "DP-400":
    "Some of the information provided is missing or invalid. Please check and try again.",
  "DP-422":
    "Some of the information provided is missing or invalid. Please check and try again.",
  "DP-401": "Please sign in to continue.",
  "DP-403": "You are not allowed to perform this action.",
  "DP-404": "The requested item could not be found.",
  "DP-409": "This conflicts with existing data. Please check and try again.",
  "DP-500": "Something went wrong on our side. Please try again later.",
  "DP-503":
    "A required service is currently unavailable. Please try again later.",
  // Emitted by the reverse proxy when a request reaches it without a valid session.
  PPGLOGOUT: "Your session has expired. Please sign in again.",
};
const FRIENDLY_DEFAULT = "Something went wrong. Please try again later.";

export const getApiException = (body) => {
  const exception = body && body.exception;
  if (!exception || typeof exception !== "object") return null;
  return Object.keys(exception).length ? exception : null;
};

// A Core description is shown verbatim when it is written for a person ("To proceed with the
// Go Live process, your app should be subscribed to an API offering Live data"). It is replaced
// by the generic text when it is a developer message: the bare "Client Error"/"Technical Error",
// anything naming fields or internals (SupportTicketId, payload, null, Identity Server ...).
// Case-sensitive: a CamelCase identifier such as SupportTicketId or ClientIdDev.
const IDENTIFIER_HINT = /\b[A-Z][a-z]+[A-Z]\w*\b/;
const TECHNICAL_HINTS =
  /\bnull\b|object reference|exception|payload|parameter|stack|sql|identity server|internal server|required field/i;

const humanDescription = (description) => {
  if (!description || typeof description !== "string") return null;
  const text = description
    .replace(/^\s*(client\s+error|technical\s+error|error)\s*:\s*/i, "")
    .trim();
  if (text.length < 12) return null;
  if (/^(client|technical) error$/i.test(text)) return null;
  if (IDENTIFIER_HINT.test(text) || TECHNICAL_HINTS.test(text)) return null;
  return /[.!?]$/.test(text) ? text : `${text}.`;
};

export const friendlyApiMessage = (exception) => {
  const code = exception && exception.code;
  const human = humanDescription(exception && exception.description);
  if (human) return human;
  if (code && FRIENDLY_BY_CODE[code]) return FRIENDLY_BY_CODE[code];
  if (code && /^HTTP-4/.test(code)) return FRIENDLY_BY_CODE["DP-400"];
  return FRIENDLY_DEFAULT;
};

export const formatApiError = (exception) => {
  const code = exception && exception.code;
  const text = friendlyApiMessage(exception);
  return code ? `${text} (${code})` : text;
};
